import config from 'config';
import { getMediaWidgetIds } from 'modules/News/utils';
import {VIDEO} from "sportinglife-react-common/mediaTypes";
import OoyalaApiClient from "modules/Ooyala/client/OoyalaApiClient";

const LOAD_MEDIA_URL = 'common/media/LOAD_MEDIA_URL';
const LOAD_OTHER_MEDIA_URL_SUCCESS = 'common/media/LOAD_OTHER_MEDIA_URL_SUCCESS';
const LOAD_VIDEO_MEDIA_URL_SUCCESS = 'common/media/LOAD_VIDEO_MEDIA_URL_SUCCESS';
const LOAD_MEDIA_URL_FAIL = 'common/media/LOAD_MEDIA_URL_FAIL';

const initialState = {};

export default function reducer(state = initialState, action = {}) {
  const id = action.mediaType === VIDEO ? "video_"+action.mediaId : action.mediaId;
  switch (action.type) {
    case LOAD_MEDIA_URL:
      return {
        ...state,
        [id]: {
          loading: true
        }
      };
    case LOAD_VIDEO_MEDIA_URL_SUCCESS:
      return {
        ...state,
        [id]: {
          ...{
            loading: false,
            loaded: true
          },
          videoData: action.result
        }
      };
    case LOAD_OTHER_MEDIA_URL_SUCCESS:
      return {
        ...state,
        [id]: {
          ...{
            loading: false,
            loaded: true
          },
          caption: action.result.default_caption,
          artefacts: action.result.artefacts
        }
      };
    case LOAD_MEDIA_URL_FAIL:
      return {
        ...state,
        [id]: {
          loading: false,
          loaded: false,
          error: action.error
        }
      };
    default:
      return state;
  }
}

export function isMediaLoaded(globalState, mediaId) {
  return globalState.common.media
      && globalState.common.media[mediaId]
      && globalState.common.media[mediaId].loaded;
}

export function loadMediaForArticles(globalState, dispatch, articles) {
  const mediaLoad = [];
  const mediaIds = new Set();

  articles.forEach(article => {
    getMediaWidgetIds(article.widgets).forEach(id => id && mediaIds.add(id));
  });

  mediaIds.forEach(mediaId => {
    if (!isMediaLoaded(globalState, mediaId)) {
      mediaLoad.push(dispatch(loadMediaUrl(mediaId)));
    }
  });

  const convertToObject = widget => widget.keys.reduce((out, kv) => { return {...out, [kv.key]: kv.value} }, {});

  articles.reduce((widgets, article) => widgets.concat(article.widgets), [])
    .filter(widget => widget.widget_type === VIDEO)
    .map(w => convertToObject(w).media_id)
    .filter(mediaId => !isMediaLoaded(globalState, mediaId))
    .forEach(mediaId => mediaLoad.push(dispatch(loadVideoMediaUrl(mediaId))));

  return Promise.all(mediaLoad);
}

export function loadVideoMediaUrl(mediaId) {
  return {
    types: [LOAD_MEDIA_URL, LOAD_VIDEO_MEDIA_URL_SUCCESS, LOAD_MEDIA_URL_FAIL],
    promise: () => OoyalaApiClient.getAsset(mediaId),
    mediaType: VIDEO,
    mediaId: mediaId
  }
}

export function loadMediaUrl(mediaId) {
  return {
    types: [LOAD_MEDIA_URL, LOAD_OTHER_MEDIA_URL_SUCCESS, LOAD_MEDIA_URL_FAIL],
    promise: (client) => client.get(`${config.api.media.loadMedia}/${mediaId}`),
    mediaType: "imageOrTip",
    mediaId: mediaId
  }
}



// WEBPACK FOOTER //
// ./modules/Common/reducers/media.js